export default __webpack_public_path__ + "static/media/Geetha Jewellers.3e6eede1.png";